function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "scale(2.6667)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21 4h-3.1a5.009 5.009 0 0 0-4.9-4h-2a5.009 5.009 0 0 0-4.9 4h-3.1a1 1 0 0 0 0 2h1v13a5.006 5.006 0 0 0 5 5h6a5.006 5.006 0 0 0 5-5v-13h1a1 1 0 0 0 0-2zm-10-2h2a3.006 3.006 0 0 1 2.829 2h-7.658a3.006 3.006 0 0 1 2.829-2zm7 17a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3v-13h12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 18a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14 18a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1z"
}));
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b8eb877f.svg";
export { ForwardRef as ReactComponent };